import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_DEALER_GET_LIST } from 'api/utilityActionTypes';

export default async function getUtilityDealerListAction(
  { state, utilityApiClient },
  { refresh } = {},
) {
  typeCheck('refresh::Maybe Boolean', refresh);
  const utilityDealerListStatePath = ['utilityDealers', 'list'];
  if (!refresh && state.get(utilityDealerListStatePath)) {
    return state.get(utilityDealerListStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_DEALER_GET_LIST,
    state: state,
    onSuccess(utilityDealerList) {
      state.set(utilityDealerListStatePath, utilityDealerList);
    },
  });
}
